/* eslint-disable */
import React, {memo, RefObject, useState, useEffect} from "react";
import styles from "./CaptionsPanel.module.css";
import Caption from "./Caption";
import {VideoCaption} from "../../../../../common/video/models/VideoCaption";
import useResponsive from "../../../../..//common/useResponsive";
import PuiTypography from "../../../../../components/elements/PuiTypography";

interface CaptionsPanelProps {
    videoId: number;
    captions: VideoCaption[];
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
}

function CaptionsPanel({videoId, captions, videoRef, currentVideoTimeMs}: CaptionsPanelProps) {
    const { isMobile, isTablet } = useResponsive();
    const [currentCaptionIndex,ChangeCurrentCaptionIndex] = useState(-1);
    const endMillisList: number[] = [];

    if(captions && captions.length > 0) {
        captions.map((function(row) {
            endMillisList.push(row.endMillis);
            return null;
        }));
    }


    // 現在のキャプションのインデックスを決める
    useEffect(() => {
        ChangeCurrentCaptionIndex(endMillisList.findIndex((endTime) => endTime > currentVideoTimeMs));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoTimeMs]);
   
    if (!(captions && captions.length > 0)) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.root}>
            <div className={styles.captionListArea}>
                <div className={styles.captionList} id="captionTop">
                    {captions.map((segment, index) => (
                        <Caption
                            key={index}
                            isCurrentCaption={index === currentCaptionIndex}
                            videoRef={videoRef}
                            startTimeMillis={segment.startMillis}
                            id={captions[index].id}
                            text={segment.transcript}
                            captionElement={document.getElementById("captionTop")}
                        >
                            <PuiTypography rows={isMobile && 4} size={isMobile ? 12 : isTablet ? 14 : 16}>
                                {segment.transcript}
                            </PuiTypography>
                        </Caption>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default memo(CaptionsPanel);
